/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-03 12:16:28
 * @FilePath: \eu-eswop-official-site\src\utils\rem.js
 * @Description:
 */
function setRem() {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDom = document.querySelector('html')
  htmlDom.style.fontSize = htmlWidth / 20 + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}
